import React, {FC} from 'react';
import classNames from 'classnames';
import {Routes} from 'constants/index';
import {Link} from 'gatsby';
import DoneIcon from 'images/svg/done.svg';

import * as styles from './styles.module.scss';

export const Success: FC<{location?: string}> = ({location}) => (
	<div className={styles.success}>
		<img
			className={styles.done}
			src={DoneIcon as string} alt='Done'
		/>
		<span className={classNames(styles.title, styles.successTitle)}>
			You're on the waitlist!
		</span>
		<span className={styles.description}>
			<p>
				We can't wait to see you soon and will update you
				when we'll be at {location}.
			</p>
			<p>
				In the meantime, <Link to={Routes.blog}>check out our
				blog</Link> for FAQs, exclusive content, and more.
			</p>
		</span>
	</div>
);
